// extracted by mini-css-extract-plugin
export default {"search":"Search_search__LR67p","input":"Search_input__JT5hI"};